import { Modal } from "antd";
import { curSym, pipViewDate } from "../../../../utils/pip";
import { act } from "react";

const OfferDetails = ({ isModal, setIsModal, data }) => {
  return (
    <Modal
      className=""
      visible={isModal}
      onCancel={() => {
        setIsModal(false);
      }}
      centered={true}
      footer={null}
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body px-4 pb-5">
            <div>
              <h4 class="mb-1 ct_fs_20">Offer Details</h4>
              {/* <p class="mb-0 ct_grey_text">
                    See full details for this newly registered user
                  </p> */}
            </div>

            <ul className="ct_webinar_grid_2 ct_webinar_grid__120_auto mt-4">
              <li>
                <p className="mb-0 ct_fs_14">Offer Title </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.offer_title || "#N/A"}
                </p>
              </li>
              <li>
                <p className="mb-0 ct_fs_14">Purpose </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.purpose || "#N/A"}
                </p>
              </li>
              <li>
                <p className="mb-0 ct_fs_14">Type </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.offer_type || "#N/A"}
                </p>
              </li>
              <li>
                <p className="mb-0 ct_fs_14">Duration </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.duration || 0} minutes
                </p>
              </li>
              <li>
                <p className="mb-0 ct_fs_14">Format </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.offer_format || "#N/A"}
                </p>
              </li>
              <li>
                <p className="mb-0 ct_fs_14">Price </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {curSym}
                  {data?.price || 0}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OfferDetails;
